import { render } from "./TreeChildComponent.vue?vue&type=template&id=30b01572"
import script from "./TreeChildComponent.vue?vue&type=script&lang=js"
export * from "./TreeChildComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__